/* Atlas Wood Company: motion.
   - Headlines rise into place once per page view. Products, collections and feature photos settle in
     once, quietly. Paragraphs and buttons do not animate; hovers and the menu carry the interaction.
   - "How we make them": one orange line is drawn across the three columns, and each step appears as the
     line reaches it, ending on a point that hands off to the manifesto's cursor. Replays on re-entry.
   - "Made by a Person": the manifesto types itself out like a typewriter when the section arrives.
   - "Built like furniture": the headline is drawn on with a soft edge while its letter-spacing settles,
     then a brass hairline opens beneath it and the paragraph follows.
   Honours prefers-reduced-motion; nothing is hidden if the script fails. */
(function () {
  var root = document.documentElement;
  var MK = '[id$="__multicolumn_qjcCYQ"]';

  /* "How we make them": pull the numeral out of each step title (runs with or without motion) */
  function makeSteps(still) {
    var sec = document.querySelector(MK);
    if (!sec) return null;
    sec.querySelectorAll('.multicolumn-card__info > h3').forEach(function (h3) {
      var t = h3.textContent.trim(), m = t.match(/^([ivx]+\.)\s+(.*)$/i);
      if (!m) return;
      h3.innerHTML = '<span class="awc-mk__num">' + m[1] + '</span><span class="awc-mk__t">' + m[2] + '</span>';
    });
    sec.classList.add('awc-mk');
    if (still) sec.classList.add('is-in');
    return sec;
  }
  /* "The Canvas Floating Frame" (Bestseller): the same frame in each wood. Choosing a wood swaps the photo
     with one orange pass, the same cut as the hero. Works with or without motion (instant swap without). */
  function species(instant) {
    var data = window.AWC_SPECIES, sec = document.querySelector('[id$="__image_with_text_CDcLEd"]');
    if (!data || !data.length || !sec) return;
    var media = sec.querySelector('.image-with-text__media'), text = sec.querySelector('.image-with-text__content');
    if (!media || !text) return;
    var imgs = [media.querySelector('img')], z = 1, cur = 0, loaded = false;
    if (!imgs[0]) return;
    imgs[0].classList.add('awc-sp__img');
    var blade = document.createElement('span'); blade.className = 'awc-sp__blade'; blade.setAttribute('aria-hidden', 'true');
    media.classList.add('awc-sp-media'); media.appendChild(blade);
    function load() {
      if (loaded) return; loaded = true;
      data.forEach(function (d, i) {
        if (!i) return;
        var im = new Image(); im.className = 'awc-sp__img'; im.alt = d.name + ' canvas floating frame on a wall'; im.src = d.img;
        im.style.clipPath = 'inset(0 100% 0 0)'; im.style.zIndex = 0; media.insertBefore(im, blade); imgs[i] = im;
      });
    }
    var ui = document.createElement('div'); ui.className = 'awc-sp';
    ui.innerHTML = '<p class="awc-sp__label"><span class="awc-sp__name"></span></p><div class="awc-sp__chips" role="radiogroup" aria-label="Frame wood"></div>';
    var chips = ui.querySelector('.awc-sp__chips'), nameEl = ui.querySelector('.awc-sp__name');
    data.forEach(function (d, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'awc-sp__chip'; b.setAttribute('role', 'radio'); b.setAttribute('aria-label', d.name);
      b.style.backgroundColor = d.hex; if (d.sw) b.style.backgroundImage = 'url(' + d.sw + ')';
      b.addEventListener('click', function () { show(i); });
      var t; b.addEventListener('mouseenter', function () { load(); t = setTimeout(function () { show(i); }, 120); });
      b.addEventListener('mouseleave', function () { clearTimeout(t); });
      chips.appendChild(b);
    });
    var btn = text.querySelector('.button');
    if (btn) text.insertBefore(ui, btn); else text.appendChild(ui);
    function label(i) {
      nameEl.textContent = data[i].name;
      if (btn && data[i].url) { btn.href = data[i].url; btn.textContent = 'Shop the ' + data[i].name + ' frame'; }   // the button goes to the chosen wood
      [].forEach.call(chips.children, function (c, k) { c.classList.toggle('is-on', k === i); c.setAttribute('aria-checked', k === i ? 'true' : 'false'); });
    }
    function show(i) {
      if (i === cur) return;
      load();
      var im = imgs[i]; if (!im) return;
      cur = i; label(i);
      im.style.zIndex = ++z; blade.style.zIndex = z + 1;
      if (instant) { im.style.transition = 'none'; im.style.clipPath = 'inset(0 0 0 0)'; return; }
      im.style.transition = 'none'; im.style.clipPath = 'inset(0 100% 0 0)'; im.offsetWidth;
      im.style.transition = ''; im.style.clipPath = 'inset(0 0 0 0)';
      blade.classList.remove('go'); blade.offsetWidth; blade.classList.add('go');
    }
    label(0);
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(); o.disconnect(); } }, { rootMargin: '400px 0px' });
      o.observe(sec);
    } else load();
  }

  /* "The wireless frame light": a dusk slider. The same room in afternoon light and in the evening; moving across
     the photo (or dragging along the ruler beneath it) brings the evening in, and the frame light carries the art.
     The handle is the menu's sightglass on a short ruler. Works with or without motion. */
  function lightSlider(still) {
    var L = window.AWC_LIGHT, sec = document.querySelector('[id$="__image_with_text_jUjhaC"]');
    if (!L || !L.eve || !sec) return;
    var media = sec.querySelector('.image-with-text__media'), item = sec.querySelector('.image-with-text__media-item');
    if (!media || !item) return;
    var eve = new Image(); eve.className = 'awc-ls__eve'; eve.alt = 'The same frame in the evening, lit by the frame light'; eve.src = L.eve;
    media.appendChild(eve); media.classList.add('awc-ls-media');
    var ui = document.createElement('div'); ui.className = 'awc-ls';
    // the control is a ruler like the menu's, but its ticks rise steadily from nothing on the left to full height on the
    // right, so it reads as light giving way to dark; an orange needle marks the level
    ui.innerHTML = '<div class="awc-lr"><span class="awc-lr__ticks" aria-hidden="true"></span><span class="awc-lr__needle" aria-hidden="true"></span>' +
      '<input class="awc-ls__range" type="range" min="0" max="100" step="1" value="25" aria-label="Dim the room, from afternoon to evening"></div>';
    media.parentNode.insertBefore(ui, media.nextSibling);
    var range = ui.querySelector('.awc-ls__range'), hint = null;
    var target = 0.25, v = 0.25, raf = null;
    function paint() { ui.style.setProperty('--v', v.toFixed(4)); media.style.setProperty('--v', v.toFixed(4)); }
    function loop() {
      v += (target - v) * (still ? 1 : 0.16);
      if (Math.abs(target - v) < 0.001) v = target;
      paint(); raf = v === target ? null : requestAnimationFrame(loop);
    }
    function set(x, fromRange) {
      target = Math.max(0, Math.min(1, x));
      if (!fromRange) range.value = Math.round(target * 100);
      if (hint) { hint.classList.add('is-gone'); }
      if (!raf) raf = requestAnimationFrame(loop);
    }
    var touched = false;
    range.addEventListener('input', function () { touched = true; set(range.value / 100, true); });
    // a one-time demonstration when the section first comes into view: the needle eases toward evening and back,
    // so it's clear the room can be dimmed (skipped if the reader gets there first)
    if (!still && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io2.disconnect();
        setTimeout(function () { if (!touched) set(0.6); }, 600);
        setTimeout(function () { if (!touched) set(0.25); }, 1900);
      }, { threshold: 0.6 });
      io2.observe(media);
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      media.addEventListener('mousemove', function (e) { touched = true; var r = media.getBoundingClientRect(); set((e.clientX - r.left) / r.width); });
    }
    paint();
  }

  if (!root.classList.contains('awc-motion')) {
    var run0 = function () { try { makeSteps(true); } catch (e) {} try { species(true); } catch (e) {} try { lightSlider(true); } catch (e) {} };
    if (document.readyState !== 'loading') run0(); else document.addEventListener('DOMContentLoaded', run0);
    return;
  }
  var RV = '.collection-list__item,.product-grid > .grid__item,.image-with-text__media-item';
  var TW = '[id$="__rich_text_N6xi7U"]', JN = '[id$="__rich_text_NppzJ7"]';
  var H = '.rich-text__heading,.image-with-text__heading,.multicolumn .title,.collection-list-title,.main-page-title,.collection-hero__title,.article-template__title';

  function split(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var frag = document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
        var o = document.createElement('span'), i = document.createElement('span');
        o.className = 'awc-w'; i.className = 'awc-wi'; i.textContent = p; o.appendChild(i); frag.appendChild(o);
      });
      n.parentNode.replaceChild(frag, n);
    });
  }
  function lines(el) {
    var top = null, line = -1;
    el.querySelectorAll('.awc-w').forEach(function (w) {
      var t = Math.round(w.getBoundingClientRect().top);
      if (top === null || Math.abs(t - top) > 4) { line++; top = t; }
      w.firstChild.style.transitionDelay = (line * 110) + 'ms';
    });
  }

  /* ---------- headlines: rise into place once ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      lines(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  /* ---------- products, collections, feature photos: settle in once ---------- */
  var rv = new IntersectionObserver(function (entries) {
    var n = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.style.setProperty('--d', (Math.min(n++, 5) * 70) + 'ms');
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      rv.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -4% 0px' });

  /* ---------- shared: one scroll loop for everything scroll-driven ---------- */
  var DESK = window.matchMedia('(min-width: 990px)').matches;   // scroll-driven on desktop; phones play on their own
  var scrubs = [], ticking = false;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function frame() { ticking = false; scrubs.forEach(function (f) { f(); }); }
  var lastScroll = 0;
  window.addEventListener('scroll', function () { lastScroll = performance.now(); }, { passive: true });
  /* Let a scroll-driven section play on by itself: once it has started, if the reader stops scrolling it keeps
     going at its own, slower pace; scrolling forward simply moves through it faster; scrolling back up takes it back. */
  function player(sec, getP, apply, cap, rate) {
    var s = 0, auto = 0, run = false, t0 = 0;
    function view() { var r = sec.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
    function show() { apply(Math.max(auto, s)); }
    function tick(t) {
      if (!view()) { run = false; return; }
      var dt = Math.min(0.1, (t - t0) / 1000); t0 = t;
      if (t - lastScroll > 250) auto = Math.max(auto, s) + rate * dt;   // only while the reader is still
      if (auto >= cap) { auto = cap; show(); run = false; return; }
      show(); requestAnimationFrame(tick);
    }
    return function () {
      var n = getP();
      if (n < s - 0.0005) auto = Math.min(auto, n);   // scrolling back up: follow the scroll back
      s = n; show();
      if (!run && s > 0 && Math.max(auto, s) < cap && view()) { run = true; t0 = performance.now(); requestAnimationFrame(tick); }
    };
  }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  /* ---------- "How I make them": scrolling draws the orange line across the three columns, and each step
     comes in as the line reaches it. Scrolling back up takes it away again. ---------- */
  function steps() {
    var sec = makeSteps(false);
    if (!sec) return;
    var list = sec.querySelector('.multicolumn-list');
    var items = [].slice.call(sec.querySelectorAll('.multicolumn-list__item'));
    if (!list || !items.length) { sec.classList.add('is-in'); return; }
    if (!DESK) {   // phones: the line draws and the steps rise on their own when the section arrives; replays on re-entry
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) requestAnimationFrame(function () { sec.classList.add('is-in'); });
          else if (e.boundingClientRect.top > 0) {
            sec.classList.add('awc-reset'); sec.classList.remove('is-in');
            requestAnimationFrame(function () { requestAnimationFrame(function () { sec.classList.remove('awc-reset'); }); });
          }
        });
      }, { threshold: 0.25 });
      o.observe(list);
      return;
    }
    // desktop: the section holds still while scrolling draws the line across; each step comes in as the line reaches it
    sec.classList.add('awc-mk--scrub', 'awc-mk--pin');
    var last = items[items.length - 1], n = items.length;
    scrubs.push(player(sec, function () {
      var r = sec.getBoundingClientRect(), vh = window.innerHeight;
      var travel = Math.max(1, sec.offsetHeight - vh), lead = vh * 0.3;
      return clamp(clamp((lead - r.top) / (travel + lead)) / 0.8);   // the last fifth holds the finished section
    }, function (p) {
      items.forEach(function (it, i) {
        var q = clamp(p * n - i);
        it.style.setProperty('--l', q.toFixed(4));
        it.style.setProperty('--q', clamp((q - 0.15) / 0.7).toFixed(4));
      });
      last.style.setProperty('--d', p >= 1 ? 1 : 0);
    }, 1, 1 / 7));   // left alone, the line takes about 7 seconds to cross
  }

  /* ---------- "Made by a Person": the manifesto is typed by scrolling. The section holds still while you scroll;
     each bit of scroll strikes the next letters (scroll back up and they lift off again). Nothing is shown ahead of
     the cursor, only blank space. The cursor always blinks wherever you stop. Before the last line it drops to a new
     line and waits through a short stretch of scroll, then "Not for everyone." is typed. ---------- */
  function typewriter() {
    var sec = document.querySelector(TW);
    var h = sec && sec.querySelector('.rich-text__heading');
    if (!h) return;
    h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
    sec.classList.add('awc-tw');
    if (DESK) sec.classList.add('awc-tw--pin');
    var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var frag = document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span'); w.className = 'awc-tw__w'; w.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < p.length; i++) { var c = document.createElement('span'); c.className = 'awc-c'; c.textContent = p[i]; w.appendChild(c); }
        frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag, n);
    });
    // "Not for everyone." gets its own line
    var ws = [].slice.call(h.querySelectorAll('.awc-tw__w')), tail = ws.slice(-3), endFirst = null;
    if (tail.length === 3 && tail.map(function (w) { return w.textContent; }).join(' ') === 'Not for everyone.') {
      var end = document.createElement('span'); end.className = 'awc-tw__end';
      tail[0].parentNode.insertBefore(end, tail[0]);
      tail.forEach(function (w, i) { if (i) end.appendChild(document.createTextNode(' ')); end.appendChild(w); });
      endFirst = tail[0].querySelector('.awc-c');
    }
    var chars = [].slice.call(h.querySelectorAll('.awc-c')), total = chars.length;
    var ems = h.querySelectorAll('em');
    var me = ems[1] ? [].slice.call(ems[1].querySelectorAll('.awc-c')) : [];
    var meEnd = me.length ? chars.indexOf(me[me.length - 1]) + 1 : -1;
    var a = endFirst ? chars.indexOf(endFirst) : total, L = total - a;
    var caret = document.createElement('span'); caret.className = 'awc-caret'; caret.setAttribute('aria-hidden', 'true');
    var shown = -1, caretAt = null;

    if (!DESK) {   // phones: it types itself when the section arrives (~28 ms a letter), holds at the start of the last line, then finishes
      var firstEm = ems[0] && ems[0].querySelector('.awc-c'), timer = null, idx = 0;
      var delayAfter = function (c, next) {
        var t = c.textContent, d = 15 + Math.random() * 8;
        if (t === '.') d = 130; else if (t === ',') d = 70;
        if (next === firstEm) d = 340;
        if (next === me[0]) d = 400;
        if (next === endFirst) d = 1400;
        if (endFirst && chars.indexOf(c) >= a) d = Math.max(d, 40 + Math.random() * 12);
        return d;
      };
      var step = function () {
        var c = chars[idx];
        if (!c) { h.classList.add('is-ended'); return; }   // the cursor keeps blinking
        c.classList.add('on');
        if (chars.indexOf(c) === meEnd - 1) h.classList.add('awc-stamp');
        c.parentNode.insertBefore(caret, c.nextSibling);
        idx++;
        if (endFirst && chars[idx] === endFirst) endFirst.parentNode.insertBefore(caret, endFirst);
        timer = setTimeout(step, delayAfter(c, chars[idx]));
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!timer && !idx) { chars[0].parentNode.insertBefore(caret, chars[0]); timer = setTimeout(step, 250); } }
          else if (e.boundingClientRect.top > 0) {
            clearTimeout(timer); timer = null; idx = 0;
            chars.forEach(function (c) { c.classList.remove('on'); });
            h.classList.remove('awc-stamp', 'is-ended');
            if (caret.parentNode) caret.parentNode.removeChild(caret);
          }
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -15% 0px' }).observe(h);
      return;
    }

    // scroll budget, as fractions of the pinned scroll: type the body, hold at the start of the last line, type the last line, rest
    var BODY = 0.76, HOLD = 0.82, LAST = 0.90;   // ~20px of scroll a letter, a long hold before the last line, then a few scrolls at rest
    function count(p) {
      if (!endFirst) return Math.ceil(clamp(p / LAST) * total);
      if (p < BODY) return Math.ceil(p / BODY * a);
      if (p < HOLD) return a;
      return a + Math.ceil(clamp((p - HOLD) / (LAST - HOLD)) * L);
    }
    function render(n) {
      if (n === shown) return;
      var from = Math.max(0, Math.min(n, shown)), to = Math.max(n, shown);
      for (var i = from; i < to; i++) chars[i].classList.toggle('on', i < n);
      if (meEnd > 0) { if (n >= meEnd && shown < meEnd) h.classList.add('awc-stamp'); else if (n < meEnd) h.classList.remove('awc-stamp'); }   // "Me." lands with a stamp
      shown = n;
      // the cursor: after the last struck letter, or waiting at the start of the last line
      var ref = n === 0 ? chars[0] : (endFirst && n === a ? endFirst : chars[n - 1].nextSibling);
      var parent = n === 0 ? chars[0].parentNode : (endFirst && n === a ? endFirst.parentNode : chars[n - 1].parentNode);
      if (caretAt !== ref || caret.parentNode !== parent) { parent.insertBefore(caret, ref); caretAt = ref; }
      h.classList.toggle('is-ended', n >= total);
    }
    scrubs.push(player(sec, function () {
      var r = sec.getBoundingClientRect(), vh = window.innerHeight;
      var travel = Math.max(1, sec.offsetHeight - vh), lead = vh * 0.25;   // typing begins a little before the section settles
      return clamp((lead - r.top) / (travel + lead));
    }, function (p) { render(count(p)); }, LAST, BODY / (a / 14)));   // left alone it types about 14 letters a second, and the pause before the last line plays out on its own
  }

  /* ---------- "Built like furniture": drawn on, tracking settles, hairline opens ---------- */
  function joinery() {
    var sec = document.querySelector(JN);
    var h = sec && sec.querySelector('.rich-text__heading');
    if (!h) return;
    var rule = document.createElement('span'); rule.className = 'awc-jn__rule'; rule.setAttribute('aria-hidden', 'true');
    h.parentNode.insertBefore(rule, h.nextSibling);
    sec.classList.add('awc-jn');
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) requestAnimationFrame(function () { sec.classList.add('is-joined'); });
        else if (e.boundingClientRect.top > 0) { sec.classList.add('awc-reset'); sec.classList.remove('is-joined'); requestAnimationFrame(function () { requestAnimationFrame(function () { sec.classList.remove('awc-reset'); }); }); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }).observe(h);
  }

  /* ---------- Hero: "Every frame starts as a board." Once the photo is fully in view, an orange blade
     makes one pass across it and the board on the jointer becomes the finished frame. ---------- */
  function hero() {
    var sec = document.querySelector('[id$="__image_with_text_fYHbez"]');
    var media = sec && sec.querySelector('.image-with-text__media');
    if (!media || !window.AWC_HERO) return;
    var after = new Image();
    after.className = 'awc-hero__after';
    after.alt = 'A hard maple floating frame on the wall, finished';
    after.src = window.AWC_HERO;
    var blade = document.createElement('span'); blade.className = 'awc-hero__blade'; blade.setAttribute('aria-hidden', 'true');
    media.appendChild(after); media.appendChild(blade); media.classList.add('awc-hero');
    var done = false;
    function cut() {
      if (done) return; done = true;
      var run = function () { requestAnimationFrame(function () { media.classList.add('is-cut'); }); };
      if (after.complete && after.naturalWidth) run(); else { after.addEventListener('load', run); after.addEventListener('error', function () { done = false; }); }
    }
    // the cut happens on the first scroll down (or straight away if the page opens already scrolled)
    function first() {
      if (root.classList.contains('awc-intro')) return;
      if (window.scrollY > 2) { cut(); window.removeEventListener('scroll', first); }
    }
    window.addEventListener('scroll', first, { passive: true });
    if (document.readyState === 'complete') first(); else window.addEventListener('load', first);
  }

  function boot() {
    try { hero(); } catch (e) {}
    try { species(false); } catch (e) {}
    try { lightSlider(false); } catch (e) {}
    try { typewriter(); } catch (e) { var s = document.querySelector(TW); if (s) s.classList.remove('awc-tw', 'awc-tw--pin'); }
    try { joinery(); } catch (e) { var j = document.querySelector(JN); if (j) j.classList.remove('awc-jn'); }
    try { steps(); } catch (e) { var k = document.querySelector(MK); if (k) { k.classList.remove('awc-mk--scrub'); k.classList.add('is-in'); } }
    document.querySelectorAll(RV).forEach(function (el) {
      if (el.closest('.awc-mk') || el.closest('.awc-ix')) return;
      el.classList.add('awc-rv'); rv.observe(el);
    });
    document.querySelectorAll(H).forEach(function (el) {
      if (el.closest('.awc-ix') || el.closest('.awc-tw') || el.closest('.awc-jn')) return;
      split(el); el.classList.add('awc-h'); io.observe(el);
    });
    root.classList.add('awc-booted');
    request();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
